// Navigation bar variants for different page types
export var NavBarVariant;
(function (NavBarVariant) {
    NavBarVariant["LOGO_ONLY"] = "logo-only";
    NavBarVariant["LOGO_WITH_LOCALE"] = "logo-locale";
    NavBarVariant["FULL_DASHBOARD"] = "full-dashboard";
})(NavBarVariant || (NavBarVariant = {}));
// Page type classification
export var PageType;
(function (PageType) {
    PageType["PUBLIC"] = "public";
    PageType["AUTHENTICATED"] = "authenticated";
    PageType["MINIMAL"] = "minimal";
})(PageType || (PageType = {}));
